import { render, staticRenderFns } from "./AIDigitalHuman.vue?vue&type=template&id=40066078&scoped=true"
import script from "./AIDigitalHuman.vue?vue&type=script&lang=js"
export * from "./AIDigitalHuman.vue?vue&type=script&lang=js"
import style0 from "./AIDigitalHuman.vue?vue&type=style&index=0&id=40066078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40066078",
  null
  
)

export default component.exports